import { render, staticRenderFns } from "./PostSubmissionDetails.vue?vue&type=template&id=5f6cd635&"
import script from "./PostSubmissionDetails.vue?vue&type=script&lang=js&"
export * from "./PostSubmissionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports